export const redirectTo = (path: string) => window.open(path, '_blank')
